export default "__VITE_ASSET__DYxjuo$1__"